import moment from 'moment';
import { commonHelper } from './commonHelper';

export const dateHelper = {
  /**
   * Format local date for API submission (date only, no time)
   * Does NOT convert to UTC — date-only values should preserve the local date the user selected.
   * @param {string|Date|moment} date - Local date from DatePicker
   * @returns {string} Local date in 'YYYY-MM-DD' format
   */
  dateForAPI: (date) => {
    if (!date) return '';
    return moment(date).format('YYYY-MM-DD');
  },
  getMonth: (date) => {
  	return commonHelper.convertUtcToLocalDate(date, 'MM');
  },
  getYear: (date) => {
  	return commonHelper.convertUtcToLocalDate(date, 'YYYY');
  },
  getTime: (date) => {
  	return commonHelper.convertUtcToLocalDate(date, 'HH:mm:ss');
  },
  /**
   * Convert local datetime to UTC for API submission (date + time)
   * @param {string|Date|moment} date - Local datetime from DatePicker with time
   * @returns {string} UTC datetime in 'YYYY-MM-DD HH:mm:ss' format
   */
  dateTimeForAPI: (date) => {
    return commonHelper.convertLocalToUtc(date, 'YYYY-MM-DD HH:mm:ss');
  },
  dateTimeForSAR: (date) => {
    return commonHelper.convertUtcToLocalDateForSar(date, 'YYYY-MM-DD HH:mm');
  },

}